"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _animations = require("../style/animations");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const AnimationContainer = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "AnimationWrapper__AnimationContainer",
  componentId: "bufferapp-ui__sc-1yjykkm-0"
})(["animation-fill-mode:forwards;display:flex;align-items:", "}justify-content:", "}outline:none;width:100%;&.stageIn{animation:", " ", " ", ";}&.stageOut{animation:", " ", " ", ";}@media (prefers-reduced-motion){&.stageIn,&.stageOut{animation-name:dissolve;}}"], _ref => {
  let {
    align
  } = _ref;
  return align;
}, _ref2 => {
  let {
    justify
  } = _ref2;
  return justify;
}, _ref3 => {
  let {
    duration
  } = _ref3;
  return `${duration}ms`;
}, _ref4 => {
  let {
    stageInAnimation
  } = _ref4;
  return stageInAnimation;
}, _ref5 => {
  let {
    easing
  } = _ref5;
  return easing;
}, _ref6 => {
  let {
    duration
  } = _ref6;
  return `${duration}ms`;
}, _ref7 => {
  let {
    stageOutAnimation
  } = _ref7;
  return stageOutAnimation;
}, _ref8 => {
  let {
    easing
  } = _ref8;
  return easing;
});
const AnimationWrapper = _ref9 => {
  let {
    align,
    children,
    dismissing,
    duration,
    easing,
    justify,
    stageInAnimation,
    stageOutAnimation,
    onDismiss
  } = _ref9;
  const [content, setContent] = (0, _react.useState)(children);
  const [hasChanged, setHasChanged] = (0, _react.useState)(false);
  const [dismissed, setDismissed] = (0, _react.useState)(false);
  const [animationLocked, setAnimationLocked] = (0, _react.useState)(false);
  const [className, setClassName] = (0, _react.useState)('stageIn');
  const shouldUpdate = children !== content && !dismissing;
  function lockAnimationDuringStaging() {
    setAnimationLocked(true);
    setTimeout(() => {
      setAnimationLocked(false);
    }, duration * 2);
  }
  function stageIn() {
    setClassName('stageIn');
  }
  function stageOut() {
    setClassName('stageOut');
  }
  (0, _react.useEffect)(() => {
    if (shouldUpdate) {
      setHasChanged(true);
      setTimeout(() => {
        stageIn();
        setContent(children);
        setHasChanged(false);
      }, duration);
    }
  }, [children]);
  (0, _react.useEffect)(() => {
    if (dismissing) {
      setTimeout(() => {
        setDismissed(true);
        onDismiss();
      }, duration - 10);
    }
  }, [dismissing]);
  (0, _react.useEffect)(() => {
    lockAnimationDuringStaging();
  }, []);
  if (!animationLocked && (hasChanged || dismissing)) {
    stageOut();
    lockAnimationDuringStaging();
  }
  return /*#__PURE__*/_react.default.createElement(AnimationContainer, {
    align: align,
    duration: duration,
    easing: easing,
    justify: justify,
    stageInAnimation: stageInAnimation,
    stageOutAnimation: stageOutAnimation,
    className: className
  }, !dismissed && content);
};
AnimationWrapper.propTypes = {
  align: _propTypes.default.string,
  children: _propTypes.default.node.isRequired,
  dismissing: _propTypes.default.bool,
  duration: _propTypes.default.number,
  justify: _propTypes.default.string,
  easing: _propTypes.default.string,
  stageInAnimation: _propTypes.default.shape({}),
  stageOutAnimation: _propTypes.default.shape({}),
  onDismiss: _propTypes.default.func
};
AnimationWrapper.defaultProps = {
  align: 'center',
  dismissing: false,
  duration: 300,
  justify: 'center',
  easing: _animations.easeOutQuart,
  onDismiss: () => {}
};
var _default = exports.default = AnimationWrapper;